/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query SmsReadQuery($vendorId: ID, $customerId: ID, $endDate: DateTime!, $startDate: DateTime!, $customerAccountSmppNameToSearch: String, $countryNameToSearch: String, $mccToSearch: String, $mncToSearch: String, $vendorNameToSearch: String, $mobileNumberToSearch: String, $dlrStatusToSearch: SMS_STATUS, $smsIdToSearch: String, $vendorSmsIdToSearch: String, $senderIdToSearch: String, $take: PositiveInt, $skip: Int) {
  SmsRead(vendorId: $vendorId, customerId: $customerId, endDate: $endDate, startDate: $startDate, customerAccountSmppNameToSearch: $customerAccountSmppNameToSearch, countryNameToSearch: $countryNameToSearch, mccToSearch: $mccToSearch, mncToSearch: $mncToSearch, vendorNameToSearch: $vendorNameToSearch, dlrStatusToSearch: $dlrStatusToSearch, mobileNumberToSearch: $mobileNumberToSearch, smsIdToSearch: $smsIdToSearch, vendorSmsIdToSearch: $vendorSmsIdToSearch, senderIdToSearch: $senderIdToSearch, take: $take, skip: $skip) {
    id,
    createdAt,
    updatedAt,
    receiptId,
    sourceAddress,
    destinationAddress,
    registeredDelivery,
    submittedAt,
    originalCopyOfMessage,
    error,
    dlr,
    transformedSourceAddress,
    isFakeDlr,
    deliveredThrough,
    isUnicodeMessage,
    messageLength,
    messageChunkSize,
    message,
    status,
    persisted__customerrateplan,
    persisted__customer,
    persisted__routeplan,
    persisted__vendorsmpp,
    persisted__vendorrateplan,
    persisted__customersmpp,
    persisted__hlrlookup,
    _totalCount,
    VendorRatePlan {
      rate,
      Mcc {
        mcc
        countryName
      },
      Mnc {
        mnc
      }
    }
    CustomerRatePlan {
      rate,
      Mcc {
        mcc
        countryName
      },
      Mnc {
        mnc
      }
    }
    RoutePlan {
      VendorAccount {
        Vendor {
          displayName
        }
      }
      Route {
        displayName,
        CustomerAccount {
          displayName,
          Customer {
            displayName,
            Billing {
              currency
            }
          }
        }
      }
      VendorAccount {
        displayName
      }
    }
  }
}
`
